export const CYCLE_EXPERIENCES = [
    // 'bleeding' and 'spotting' removed — now captured via the flowLevel spectrum
    { key: 'cramping', label: 'Cramping', emoji: '😣' },
    { key: 'bloating', label: 'Bloating', emoji: '🫧' },
    { key: 'breast_tenderness', label: 'Breast Tenderness', emoji: '⚡' },
    { key: 'headache', label: 'Headache', emoji: '🤕' },
    { key: 'fatigue', label: 'Fatigue', emoji: '😴' },
    { key: 'mood_swings', label: 'Mood Swings', emoji: '🎭' },
    { key: 'acne', label: 'Acne', emoji: '😖' },
    { key: 'cravings', label: 'Cravings', emoji: '🍫' },
    { key: 'backache', label: 'Backache', emoji: '💆' },
    { key: 'nausea', label: 'Nausea', emoji: '🤢' },
    { key: 'insomnia', label: 'Insomnia', emoji: '🌙' },
    { key: 'discharge', label: 'Discharge', emoji: '💦' },
];
export const FLOW_LEVELS = ['none', 'spotting', 'light', 'medium', 'heavy'];
/** Flow levels that represent active bleeding (excludes 'none'). */
export const ACTIVE_FLOW_LEVELS = ['spotting', 'light', 'medium', 'heavy'];
/** Flow levels that count as menstrual-period bleeding for cycle prediction (excludes spotting). */
export const PERIOD_FLOW_LEVELS = ['light', 'medium', 'heavy'];
export const DEFAULT_CYCLE_LENGTH = 28;
/** Minimum valid cycle length in days. Used across prediction, facets, insights, and UI validation. */
export const MIN_CYCLE_LENGTH = 18;
/** Maximum valid cycle length in days. */
export const MAX_CYCLE_LENGTH = 45;
/** Minimum gap (days) between bleeding dates to consider it a new period start rather than continuation/spotting. */
export const NEW_PERIOD_GAP_DAYS = 3;
// Pain quality descriptors (canonical source)
export const PAIN_QUALITIES = [
    'aching', 'burning', 'throbbing', 'stabbing', 'tender',
    'dull', 'sharp', 'radiating', 'crampy', 'pressure',
    'tingling', 'shooting', 'sore', 'stinging', 'heavy',
];
// Experience severity levels
export const EXPERIENCE_SEVERITY_LEVELS = [
    { value: 1, label: 'Mild', color: '#22C55E' },
    { value: 2, label: 'Moderate', color: '#F59E0B' },
    { value: 3, label: 'Severe', color: '#EF4444' },
];
// Cervical mucus types for fertility tracking
export const CERVICAL_MUCUS_TYPES = [
    { key: 'dry', label: 'Dry', emoji: '⚪' },
    { key: 'sticky', label: 'Sticky', emoji: '🟡' },
    { key: 'creamy', label: 'Creamy', emoji: '⚪' },
    { key: 'watery', label: 'Watery', emoji: '💧' },
    { key: 'eggwhite', label: 'Egg White', emoji: '🥚' },
];
// Ovulation test result options
export const OVULATION_TEST_RESULTS = [
    { key: 'negative', label: 'Negative', color: '#9CA3AF' },
    { key: 'low', label: 'Low', color: '#FCD34D' },
    { key: 'high', label: 'High', color: '#F97316' },
    { key: 'peak', label: 'Peak', color: '#EF4444' },
];
// Exercise intensity levels
export const EXERCISE_INTENSITIES = [
    { key: 'light', label: 'Light', color: '#22C55E' },
    { key: 'moderate', label: 'Moderate', color: '#F59E0B' },
    { key: 'vigorous', label: 'Vigorous', color: '#EF4444' },
];
// Meal types
export const MEAL_TYPES = [
    { key: 'breakfast', label: 'Breakfast', emoji: '🌅' },
    { key: 'lunch', label: 'Lunch', emoji: '☀️' },
    { key: 'dinner', label: 'Dinner', emoji: '🌙' },
    { key: 'snack', label: 'Snack', emoji: '🍎' },
];
// Common exercise types for autocomplete
export const COMMON_EXERCISE_TYPES = [
    'walking', 'running', 'yoga', 'cycling', 'swimming',
    'strength training', 'pilates', 'dancing', 'hiking', 'stretching',
    'elliptical', 'rowing', 'HIIT', 'barre', 'tai chi',
];
// Common diet tags for correlation analysis
export const COMMON_DIET_TAGS = [
    'dairy', 'gluten', 'sugar', 'caffeine', 'alcohol',
    'processed', 'spicy', 'fried', 'high-fiber', 'anti-inflammatory',
    'soy', 'red meat', 'fermented', 'raw', 'organic',
];
